export enum ChatCancelReasonEnum {
  AgentCancellation = 'AgentCancellation',
  AgentSpamMarking = 'AgentSpamMarking',
  MailProviderVerdict = 'MailProviderVerdict',
  SpamListMatch = 'SpamListMatch',
  MergeAbsorption = 'MergeAbsorption',
}
